export class ModalOptions {

    /**
     * Executes when the accept button is clicked, but before the modal is dismissed
     */
    public onOkClickedCallBack: (event: Event) => void;

    /**
     * Executes when the cancel button is clicked, but before the modal is dismissed
     */
    public onCancelClickedCallBack: (event: Event) => void;

    /*
     * Executes whenever the modal is going to close, but before the modal is dismissed
     * May not be implemented on every modal type
     */
    public onBeforeModalClose: (event: Event) => void;

    // using custom getter routines for all properties to always pass back an empty string.
    //  we don't want to have to do null tests wherever these are used.
    private _backdropCssClass: string = '';
    public get backdropCssClass(): string {
        return (this._backdropCssClass ? this._backdropCssClass : 'default');
    }
    public set backdropCssClass(value: string) {
        this._backdropCssClass = value;
    }

    private _title: string = '';
    public get title(): string {
        return (this._title ? this._title : '');
    }
    public set title(value: string) {
        this._title = value;
    }

    private _content: string = '';
    public get content(): string {
        return (this._content ? this._content : '');
    }
    public set content(value: string) {
        this._content = value;
    }

    // leave this as type 'any'. It needs to start as null so we can detect if it changed.
    private _closeOnBackdropClick: any = null;
    public get closeOnBackdropClick(): boolean {
        return (this._closeOnBackdropClick !== null ? this._closeOnBackdropClick : true);
    }
    public set closeOnBackdropClick(value: boolean) {
        this._closeOnBackdropClick = value;
    }

    private _useDefaultContentHolder: any = null;
    public get useDefaultContentDisplay(): boolean {
        return (this._useDefaultContentHolder !== null ? this._useDefaultContentHolder : true);
    }
    public set useDefaultContentDisplay(value: boolean) {
        this._useDefaultContentHolder = value;
    }

    private _showCancel: boolean = false;
    public get showCancel(): boolean {
        return this._showCancel;
    }
    public set showCancel(value: boolean) {
        this._showCancel = value;
    }

    private _footerText: string = null;
    public get footerText(): string {
        return this._footerText;
    }
    public set footerText(value: string) {
        this._footerText = value;
    }

    private _acceptText: string = 'OKAY';
    public get acceptText(): string {
        return this._acceptText;
    }
    public set acceptText(value: string) {
        this._acceptText = value;
    }

    private _cancelText: string = 'CANCEL';
    public get cancelText(): string {
        return this._cancelText;
    }
    public set cancelText(value: string) {
        this._cancelText = value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/models/modal-options.model.ts